import { render } from "./subjects-index.vue?vue&type=template&id=bebb9730"
import script from "./subjects-index.vue?vue&type=script&lang=js"
export * from "./subjects-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__